import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import FormatDate from "../../formatdatetime";
import { useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";
import { useNavigate } from "react-router-dom";
import { baseurl } from "../../constant";
import Loading from "../../loading";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const Mywallet = () => {
  const [data, setdata] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalrecord, settotalrecord] = useState();
  const [startdate, setstartdate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  const [enddate, setenddate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  const [keyword, setkeyword] = useState();
  const [status, setstatus] = useState();
  const [totalCRAmount, settotalCRAmount] = useState(0);
  const [totalCRRecord, settotalCRRecord] = useState(0);
  const [totalDRAmount, settotalDRAmount] = useState(0);
  const [totalDRRecord, settotalDRRecord] = useState(0);
  const [by, setby] = useState();
  const [loading, setloading] = useState(false);
  const [datalength, setdatalength] = useState();

  const formattedNumber = (number) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(number);

  const tableRef = useRef(null);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "my upi wallet report",
    sheet: "Users",
  });

  const token = localStorage.getItem("authToken");
  const pageRecord = 50;
  const totalPage = Math.ceil(totalrecord / pageRecord);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  var pages = [];
  const maxvisablepage = 8;
  if (totalPage <= maxvisablepage) {
    for (let i = 1; i <= totalPage; i++) {
      pages.push(i);
    }
  } else {
    if (currentPage <= 3) {
      // Show first 3 pages, then ellipsis, then last page
      pages.push(1, 2, 3, ".......", totalPage);
    } else if (currentPage >= totalPage - 2) {
      // Show first page, then ellipsis, then last 3 pages
      pages.push(1, totalPage - 2, totalPage - 1, totalPage);
    } else {
      // Show first page, ellipsis, current page & its neighbors, ellipsis, last page
      pages.push(
        1,

        currentPage - 1,
        currentPage,
        currentPage + 1,

        totalPage
      );
    }
  }

  // const getdata1 = async () => {
  //   setloading(true);
  //   const result = await axios.post(baseurl + "myUpiWalletAuth", {
  //     token: token,
  //     pageno: currentPage,
  //     pageRecord: pageRecord,
  //     fromDate: startdate.replaceAll('/', '-'),
  //     fromDate: enddate.replaceAll('/', '-'),
  //     keyword: keyword,
  //     status: status,
  //     by: by,
  //   });
  //   setdata(result.data);
  //   settotalCRAmount(result.data.totalCRAmount);
  //   settotalCRRecord(result.data.totalCRRecord);
  //   settotalDRAmount(result.data.totalDRAmount);
  //   settotalDRRecord(result.data.totalDRRecord);
  //   settotalrecord(result.data.totalRecord);
  //   setdatalength(result.data.data.length);
  //   setCurrentPage(1);
  //   setloading(false);
  // };

  const getdata = async () => {
    setloading(true);
    const result = await axios.post(baseurl + "myUpiWalletAuth", {
      token: token,
      pageno: currentPage,
      pageRecord: pageRecord,
      fromDate: startdate,
      toDate: enddate,
      keyword: keyword,
      status: status,
      by: by,
    });
    setdata(result.data);
    settotalCRAmount(result.data.totalCRAmount);
    settotalCRRecord(result.data.totalCRRecord);
    settotalDRAmount(result.data.totalDRAmount);
    settotalDRRecord(result.data.totalDRRecord);
    settotalrecord(result.data.totalRecord);
    setdatalength(result.data.data.length);
    setloading(false);
  };
  useEffect(() => {
    getdata();
  }, [currentPage]);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-4 col-md-6 mb-2 mt-2">
            <div className="card border-left-success shadow h-100 py-2">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                      <a href="#">Total Credit Fund</a>
                    </div>
                    <div
                      className="h5 mb-0 font-weight-bold text-gray-800"
                      id="totalCrBlock"
                    >
                      {formattedNumber(totalCRAmount)} / {totalCRRecord}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-md-6 mb-2 mt-2">
            <div className="card border-left-primary shadow h-100 py-2">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                      <a href="#">Total Debit Fund</a>
                    </div>
                    <div
                      className="h5 mb-0 font-weight-bold text-gray-800"
                      id="totalDrBlock"
                    >
                      {formattedNumber(totalDRAmount)} / {totalDRRecord}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <div id="leadFilterForm" method="post" accept-charset="utf-8">
              <div className="row">
                <div className="col-sm-12">
                  <h4>
                    <b>My UPI Wallet</b>
                  </h4>
                </div>

                <div className="col-sm-2">
                  <select
                    className="form-control"
                    id="status"
                    name="status"
                    value={status}
                    onChange={(e) => {
                      setstatus(e.target.value);
                    }}
                  >
                    <option value="0">All Status</option>
                    <option value="1">CR</option>
                    <option value="2">DR</option>
                  </select>
                </div>

                <div className="col-sm-2">
                  <select
                    className="form-control"
                    id="by"
                    name="by"
                    value={by}
                    onChange={(e) => {
                      setby(e.target.value);
                    }}
                  >
                    <option value="0">By</option>
                    <option value="1"> By Manual</option>
                    <option value="2">By Payout</option>
                  </select>
                </div>

                <div className="col-sm-2">
                  <DatePicker
                    className="form-control datepick"
                    selected={startdate}
                    onChange={(date) => setstartdate(date)}
                    dateFormat="yyyy-MM-dd"
                    placeholderText={startdate}
                  />
                </div>
                <div className="col-sm-2">
                  {" "}
                  <DatePicker
                    className="form-control datepick"
                    selected={enddate}
                    onChange={(date) => setenddate(date)}
                    dateFormat="yyyy-MM-dd"
                    placeholderText={enddate}
                  />
                </div>
                <div className="col-sm-2">
                  <form
                    action="https://www.payol.in/portal/wallet/myWalletList"
                    id="leadFilterForm"
                    method="post"
                    accept-charset="utf-8"
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Keyword"
                    name="keyword"
                    value={keyword}
                    onChange={(e) => setkeyword(e.target.value)}
                  />
                </div>

                <div className="col-sm-2">
                  <button
                    type="button"
                    className="btn btn-success"
                    id="myWalletSearchBtn"
                    onClick={() => (setCurrentPage(1), getdata())}
                  >
                    Search
                  </button>

                  <button
                    type="submit"
                    className="btn btn-success"
                    onClick={onDownload}
                  >
                    Export
                  </button>
                </div>
              </div>
            </div>{" "}
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {loading ? (
                <div>
                  <Loading />
                </div>
              ) : (
                <table
                  ref={tableRef}
                  className="table table-bordered table-striped"
                  id="myWalletDataTable"
                  width="100%"
                  cellspacing="0"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>MemberID</th>
                      <th>Name</th>
                      <th>Before Amount</th>
                      <th>Cr/Dr Amount</th>
                      <th>After Amount</th>
                      <th>Date Time</th>
                      <th>Type</th>
                      <th>Description</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {datalength > 0 ? (
                      data.data.map((item, index) => (
                        <tr>
                          <td>{(currentPage - 1) * pageRecord + index + 1}</td>
                          <td>{item.user_code}</td>
                          <td>{item.name}</td>
                          <td>{item.before_balance}/-</td>
                          {item.type == 1 && (
                            <th style={{ color: "green" }}>{item.amount}/-</th>
                          )}
                          {item.type == 2 && (
                            <td style={{ color: "red" }}>{item.amount}/-</td>
                          )}
                          <td>{item.after_balance}/-</td>
                          <td>{FormatDate(item.created)}</td>
                          {item.type == 2 && (
                            <td style={{ color: "red" }}>Dr</td>
                          )}
                          {item.type == 1 && (
                            <td style={{ color: "green" }}>Cr</td>
                          )}
                          <td>{item.description}</td>
                          {item.status == 1 && (
                            <td style={{ color: "green" }}>Active</td>
                          )}
                          {item.status == 0 && (
                            <td style={{ color: "red" }}>Deactive</td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <th colspan="11" style={{ textAlign: "center" }}>
                          There is no data in table
                        </th>
                      </tr>
                    )}
                  </tbody>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>MemberID</th>
                      <th>Name</th>
                      <th>Before Amount</th>
                      <th>Cr/Dr Amount</th>
                      <th>After Amount</th>
                      <th>Date Time</th>
                      <th>Type</th>
                      <th>Description</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                </table>
              )}
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage == 1}
                style={{
                  padding: "10px 15px",
                  margin: "5px",

                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                previous
              </button>

              {pages.map((page, index) => (
                <button
                  key={index}
                  onClick={() => page !== "..." && handlePageChange(page)}
                  style={{
                    padding: "10px 15px",
                    margin: "5px",
                    backgroundColor: currentPage === page ? "red" : "#f0f0f0",
                    color: currentPage === page ? "#fff" : "#000",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    cursor: page === "..." ? "default" : "pointer",
                    fontWeight: page === "..." ? "bold" : "normal",
                  }}
                  disabled={page === "..."}
                >
                  {page}
                </button>
              ))}

              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage == totalPage}
                style={{
                  padding: "10px 15px",
                  margin: "5px",

                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Mywallet;
